import commentService from 'resources/comment/comment.service';

import * as auditOperations from 'resources/audit/audit.operations';

// you can have several comments on one task from several audits
const resolveAuditComments = async (query) => {
  const resolvedComments = await commentService.resolveAuditComments(query);

  const [comment] = resolvedComments;

  await auditOperations.actualizeAuditStatus(comment.audit_id);

  return resolvedComments;
};

export default resolveAuditComments;
